export enum ProgramMasterInstrumentsDropdownNameEnum {
  Name_ASC = 'Name: A-Z',
  Name_DESC = 'Name: Z-A',
  Type_PRE_POST = 'Type: Pre-Post',
  Type_POST_PRE = 'Type: Post-Pre',
}
